"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ternaryClamp(min, mid, max) {
    return mid < min ? min : mid < max ? mid : max;
}
exports.default = ternaryClamp;
